import { SearchRequestAlgorithm } from '@videoblocks/search-service-client';

export const defaultAlgorithm: SearchRequestAlgorithm = {
    bucketByFilterCounts: true,
    collapse: {
        field: 'collapsed_set_id',
        dynamic: true,
    },
    spellingCorrection: {
        enableSpellingCorrection: true,
        numAlternativeSpellingsForSuggestion: 1,
    },
};

export function getStringifiedAlgorithm(algorithm: SearchRequestAlgorithm): string {
    return JSON.stringify(algorithm);
}
